import { Component, OnInit } from '@angular/core';
import { E5coreUiSearchMenuBase } from './e5core-ui-search-menu-base';

@Component({
  selector: 'e5core-ui-search-menu-material',
  templateUrl: './e5core-ui-search-menu-material.component.html',
  styleUrls: ['./e5core-ui-search-menu-material.component.css']
})
export class E5coreUiSearchMenuMaterialComponent extends E5coreUiSearchMenuBase {

  constructor() {
    super();
  }

  ngOnInit() {
  }

}
